import { Fragment } from 'react';
import { Divider, List, ListItem, Panel, PanelInset } from '@customerio/pluma-components/react';
import { GroupedChecklistGroup } from './grouped-checklist-group';
import type { CheckboxGroup, ToggleDelta } from './types';

type GroupedChecklistProps = {
  groups: CheckboxGroup[];
  selectedItems: string[];
  onChange: (delta: ToggleDelta) => unknown;
  isDisabled: boolean;
};

/**
 * A panel of collapsible checkbox groups: the group header checkbox selects or clears the whole
 * group and reflects an indeterminate state when only some of its items are selected.
 *
 * Ported from the Ember `grouped-checklist`, which is itself a port of `FlyGroupedChecklist` —
 * the design has not been revisited, so this deliberately matches the existing behaviour rather
 * than reinterpreting it.
 */
export function GroupedChecklist({ groups, selectedItems, onChange, isDisabled }: GroupedChecklistProps) {
  return (
    <Panel>
      <PanelInset p="0" role="table">
        <List styleType="none" data-test-grouped-checklist role="rowgroup">
          {groups.map((group, index) => (
            <Fragment key={group.label}>
              {index === 0 ? null : (
                <ListItem p="0" role="presentation" aria-hidden="true">
                  <Divider />
                </ListItem>
              )}
              <GroupedChecklistGroup
                group={group}
                selectedItems={selectedItems}
                isDisabled={isDisabled}
                onChange={onChange}
              />
            </Fragment>
          ))}
        </List>
      </PanelInset>
    </Panel>
  );
}
